import { flowApi } from '.';
import { TAG_TYPES } from 'types/services';
import type { GetViewColumnsReq, GetViewColumnsRes, UpdateViewColumnsReq, UpdateViewColumnsRes } from 'types';

export const viewColumnsService = flowApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getViewColumns: builder.query<GetViewColumnsRes, GetViewColumnsReq>({
      query: ({ viewId }) => ({
        url: `Views/${viewId}/Columns`,
        method: 'GET',
      }),
      providesTags: [
        {
          type: TAG_TYPES.COLUMNS,
          id: 'LIST',
        },
      ],
    }),
    getFilterViewColumns: builder.query<GetViewColumnsRes, GetViewColumnsReq>({
      query: ({ viewId }) => ({
        url: `Views/${viewId}/Columns/Filter`,
        method: 'GET',
      }),
    }),
    getUsableViewColumns: builder.query<GetViewColumnsRes, GetViewColumnsReq>({
      query: ({ viewId }) => ({
        url: `Views/${viewId}/Columns/Usable`,
        method: 'GET',
      }),
    }),
    updateViewColumns: builder.mutation<UpdateViewColumnsRes, UpdateViewColumnsReq>({
      query: ({ viewId, viewFormItems }) => ({
        url: `Views/${viewId}/Columns`,
        method: 'PUT',
        body: {
          viewFormItems,
        },
      }),
    }),
  }),
});
export const { useGetViewColumnsQuery, useGetFilterViewColumnsQuery, useLazyGetViewColumnsQuery } = viewColumnsService;
